import Box from '@mui/material/Box'
import { StructuredContentDocument } from '@repo/supergraph/structuredContent/types'
import { StructuredContentRenderer } from '../..'
import type { ColorToken } from '../../types';
import { FeatureViewed } from '@repo/segment/components/FeatureViewed';

export type Props = StructuredContentDocument<{
  backgroundColor?: ColorToken;
  children: StructuredContentDocument;
}>;

export function NWVerifiedContainer({ props }: Props) {
  const { children, backgroundColor = 'neutral.lightest' } = props;

  return (
    <FeatureViewed entityName="banking_rating_methodology" entitySection="banking">
      <Box
        sx={{
          backgroundColor: backgroundColor,
          position: 'relative',
          borderRadius: { xs: 0, sm: 3, md: 3 },
          padding: {
            xs: 3,
            md: '1.5rem',
            xl: '2rem'
          },
        }}
      >
        <StructuredContentRenderer doc={children} />
      </Box>
    </FeatureViewed>
  )
}
